import React, { useEffect, useState } from "react";
import Plot from "react-plotly.js";

const BarChartCount = ({ contactData }) => {
  const [plotData, setPlotData] = useState([]);
  const [layout, setLayout] = useState({});

  useEffect(() => {

    if (!Array.isArray(contactData) || contactData.length === 0) {
      setPlotData([]);
      return;
    }

    const contactMap = new Map();
    contactData.forEach(({ anPosition, contactPosition }) => {
      if (!contactMap.has(anPosition)) {
        contactMap.set(anPosition, new Set());
      }
      contactMap.get(anPosition).add(contactPosition);
    });


    const processedData = Array.from(contactMap.entries())
      .map(([position, contacts]) => ({
        position: position,
        count: contacts.size,
      }))
      .sort((a, b) => a.position - b.position);


    const xPositions = processedData.map(d => d.position);
    const yCounts = processedData.map(d => d.count);

    setPlotData([
      {
        x: xPositions,
        y: yCounts,
        type: "bar",
        hovertemplate: "Residue %{x}<br>Contact: %{y}<extra></extra>",
        marker: {
          showscale: false,
          color: '#58c5bf'
        },
      },
    ]);

    setLayout({
      autosize: true,
       font: { size: 9 },
      title: {
          text: "Contacts per Residue",
        },
      xaxis: {
        type: "category",
        title: { text: "Residue Position" },
      },
      yaxis: {
        title: { text: "# of contact" },
      },
      margin: { t: 50, b: 60, l: 60, r: 40 },
    });
  }, [contactData]);

  return (
    <div className="aspect-square card">
      <Plot
        data={plotData}
        layout={layout}
        useResizeHandler
        style={{ width: "100%", height: "100%" }}
      />
    </div>
  );
};

export default BarChartCount;